var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.25V4.4375C6.1875 3.98995 6.36529 3.56072 6.68176 3.24426C6.99823 2.92779 7.42745 2.75 7.875 2.75H12.375C12.8226 2.75 13.2518 2.92779 13.5682 3.24426C13.8847 3.56072 14.0625 3.98995 14.0625 4.4375V14.5625C14.0625 15.0101 13.8847 15.4393 13.5682 15.7557C13.2518 16.0722 12.8226 16.25 12.375 16.25H7.875C7.42745 16.25 6.99823 16.0722 6.68176 15.7557C6.36529 15.4393 6.1875 15.0101 6.1875 14.5625V11.75M9 7.25L11.25 9.5M11.25 9.5L9 11.75M11.25 9.5H1.6875",
    stroke: "#80868D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/logOutIcon.b7f16a149dea12d50ed14699502d5f78.svg";
export { ForwardRef as ReactComponent };